import { capitalizeFirstLetter, getUrl } from '../../../../utilities';
import * as React from 'react';
import HighLightedText from './HighLightedText';
import styled from 'styled-components';
import { rem } from 'polished';
import { Link } from 'react-router';
import { __ } from '@bart.sk-eshop/react-i18n/lib';
import { CategoryTextStyle, MoreButton } from './styles';

const List = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
`;

const SearchLink = styled(Link)`
  display: flex;
  align-items: center;
  color: inherit;
  &:hover {
    color: ${({ theme }) => theme.color.primary};
    text-decoration: none;
  }
  &.wrap {
    flex-wrap: wrap;
  }
`;

const CategorySeparator = styled.p`
  ${CategoryTextStyle};
  margin: 0 ${rem(2)};
`;

const Item = styled.div`
  color: inherit;
  cursor: pointer;
  text-decoration: none;
  display: flex;
  align-items: center;
  ${({ theme }) => theme.transition('color')};
  &:hover {
    color: ${({ theme }) => theme.color.primary};
    text-decoration: none;
  }

  padding: ${rem(7)};
  margin-bottom: 0px;

  border-top: 1px solid ${({ theme }) => '#f2f2f2'};

  :last-child {
    border-bottom: 1px solid ${({ theme }) => '#f2f2f2'};
  }
`;

const Category = styled(Item)`
  margin: 0;
  flex-wrap: wrap;
  position: relative;
  max-width: ${rem(757)};
  &:last-child {
    margin-bottom: ${rem(10)};
  }
  &:hover {
    color: inherit;
  }
`;

const MoreButtonStyled = styled(MoreButton)`
  margin: ${rem(8)} 0;
`;

interface CategoryListProps {
  categories: any;
  searchedQuery: string;
  onRedirect?: (url) => void;
  onMoreClick?: () => void;
}

const CategoryListFull = (props: CategoryListProps) => {
  const { categories, onRedirect, searchedQuery, onMoreClick } = props;

  return (
    <>
      {categories?.catalog_category?.length ? (
        <List>
          {categories.catalog_category.map((category, index) => (
            <Category key={index}>
              <SearchLink
                className={'wrap'}
                to={getUrl(category.url)}
                onClick={onRedirect?.bind(undefined, category.url)}
              >
                {category.parent_categories?.map((parentCategory, index) => (
                  <React.Fragment key={index}>
                    <HighLightedText
                      text={capitalizeFirstLetter(parentCategory.category_name)}
                      highlight={searchedQuery}
                    />
                    <CategorySeparator>/</CategorySeparator>
                  </React.Fragment>
                ))}
                <HighLightedText
                  text={capitalizeFirstLetter(category.category_name)}
                  highlight={searchedQuery}
                />
              </SearchLink>
            </Category>
          ))}
          {onMoreClick &&
          categories.total - categories.catalog_category.length > 0 ? (
            <MoreButtonStyled onClick={onMoreClick}>
              {`${__('Zobraziť viac kategórií')} (${
                categories.total - categories.catalog_category.length
              })`}
            </MoreButtonStyled>
          ) : (
            ''
          )}
        </List>
      ) : (
        ''
      )}
    </>
  );
};

export default CategoryListFull;
